import { FormikErrors, getIn } from "formik";

export const getErrorMessage = <T>(
  errors: FormikErrors<T>,
  name: string
): string | undefined => {
  const error = getIn(errors, name);
  return error ?? undefined;
};